import React, { useEffect, useRef, useState } from "react";
import { withRouter, useHistory,useLocation } from "react-router-dom";

import {atom, useRecoilState} from 'recoil';

import {selectedExperimentState,seletedPatientIdState,weeklyLastDateState,isCurrentBloodSugarAtom, annotationChartYAxisAtom} from '../../states/recoilState';

import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import CircularProgress from '@mui/material/CircularProgress';
import Badge from '@mui/material/Badge';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

// import { Label } from "reactstrap";
// import '../../App.css'
//jQuery librarie
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-select/js/dataTables.select"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import AnnotationChart from './Charts/AnnotationChart';
import { applyStoredGlucose, fetchStoredGlucoseMap } from '../../utils/storedGlucose';
import RawCurrentChart from './Charts/RawCurrentChart';

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Unstable_Grid2';
import { CardContent, Typography } from "@mui/material";
import { agmsClientRequestGet, agmsClientDownloadGet } from "../../apis/request";
import secureLocalStorage from "react-secure-storage";

//기간 : {dateRange.startYear}-{dateRange.startMonth}-{dateRange.startDate} ~ {dateRange.endYear}-{dateRange.endMonth}-{dateRange.endDate}
import USER_IDENTITY from '../../constants/Constants';
import { useTranslation } from "react-i18next";
import { localDayKey, parseServerTime, formatServerTime } from "../../utils/serverTime";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  border: '1.5px solid #D3D3D3'
}));

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

// 혈당 다운로드 팝업 전용(더 크게)
const glucoseStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 560,
  maxWidth: '92vw',
  bgcolor: 'background.paper',
  borderRadius: '12px',
  boxShadow: 24,
  p: 4,
};

function valuetext(value) {
  return `${value}°C`;
}


const WeeklyChartList = () => {
	const { t:translate, i18n } = useTranslation();
	const history = useHistory();
	const location = useLocation();

	//타겟 혈당
	const [targetGlucose, setTargetGlucose] = useState({
		low: 80,
		high: 130
	});

	const [weeklyLastDate, setWeeklyLastDate] = useRecoilState(weeklyLastDateState);
	const [cardList, setCardList] = useState([{
		avgGlucose : 0,
		exceedUpperPercent : 0,
		exceedLowerPercent : 0
	}]);
	const [selectedPatientId, setSeletedPatientId] = useRecoilState(seletedPatientIdState);
	const [dateList, setDateList] = useState([]);

	const [graphLoading, setGraphLoading] = useState(true);
	const [isCurrentBloodSugar, setIsCurrentBloodSugar] = useRecoilState(isCurrentBloodSugarAtom);

	const [dateRange, setDateRange] = useState({
		startYear: '0000',
		startMonth: '00',
		startDate: '00',
		endYear: '0000',
		endMonth: '00',
		endDate: '00'
	});
	const [patientValue, setPatientValue] = useState({
		name: '' ,
		code: ''
	}); 
	const [apiResult, setApiResult] = useState(
	{
		activePercent:[],
		maxGlucose:[],
		minGlucose:[],
		eventCount:[],

		dayGraphData:[],
		sbgmcount:[],
		exceedLowerPercent:[],
		exceedUpperPercent:[],
		avgGlucose:[]
	}
	);

	const [maxList, setMaxList] = useState([
		{
			max_value: null,
			created_at: '00:00:00'
		},
		{
			max_value: null,
			created_at: '00:00:00'
		},
		{
			max_value: null,
			created_at: '00:00:00'
		}
	]);

	const [minList, setMinList] = useState([
		{
			min_value: null,
			created_at: '00:00:00'
		},
		{
			min_value: null,
			created_at: '00:00:00'
		},
		{
			min_value: null,
			created_at: '00:00:00'
		}
	]);

	const days = [translate('sun'), translate('mon'), translate('tue'), translate('wed'), translate('thu'), translate('fri'), translate('sat')];

	const [xMinutes, setXminutes] = React.useState(1);

	const handleChange = (event) => {
	setXminutes(event.target.value);
	};

	// 최고 관리자(1001) 전용 — raw 전류(WE1/WE2) 보기. SUB_ADMIN·일반 유저는 버튼 자체가 없음(서버도 /api/admin/** 게이트로 차단).
	const isSuperAdmin = Number(secureLocalStorage.getItem("role")) === 1001;
	// 일반관리자(1002) 이상 — 혈당 데이터 다운로드(기간/전체) 기능 노출 (사용자 1003은 숨김)
	const isSubAdminOrAbove = [1001, 1002].includes(Number(secureLocalStorage.getItem("role")));
	// 혈당 다운로드 팝업 — 기간(시작일~종료일) 설정 / 전체 다운로드
	const [glucoseDlOpen, setGlucoseDlOpen] = React.useState(false);
	const [gFrom, setGFrom] = React.useState('');
	const [gTo, setGTo] = React.useState('');
	//날짜 카드별 개별 토글: { [카드index]: { we1: bool, we2: bool } }
	const [rawShowByCard, setRawShowByCard] = React.useState({});
	const [rawCurrentByDay, setRawCurrentByDay] = React.useState(null);
	const [rawLoading, setRawLoading] = React.useState(false);

	//최초 체크 시 1회만 조회, 이후엔 토글만
	const ensureRawData = async () =>{
	if(rawCurrentByDay !== null){
		return true;
	}
	try{
		setRawLoading(true);
		const graphUserId = secureLocalStorage.getItem('adminViewUserId') ?? (USER_IDENTITY === null ? secureLocalStorage.getItem('authUser') : USER_IDENTITY);
		const startedDt = secureLocalStorage.getItem('userDeviceStartDate');

		const res = await agmsClientRequestGet(
			`/api/admin/graph/raw-current?user_id=${graphUserId}&started_dt=${startedDt}`
		);

		//날짜(yyyy-MM-dd)별로 묶어서 카드와 매칭
		const byDay = {};
		if(res && res.dateTimeList){
			for(let i = 0; i < res.dateTimeList.length; i++){
				const key = localDayKey(res.dateTimeList[i]); // ISO UTC → 브라우저 로컬 날짜(substring 금지)
				if(key === null){
					continue;
				}
				if(!byDay[key]){
					byDay[key] = { times: [], we: [], ae: [] };
				}
				byDay[key].times.push(res.dateTimeList[i]);
				byDay[key].we.push(res.weList[i]);
				byDay[key].ae.push(res.aeList[i]);
			}
		}
		setRawCurrentByDay(byDay);
		setRawLoading(false);
		return true;
	}
	catch(error){
		alert(translate('download_failed'));
		setRawLoading(false);
		return false;
	}
	}

	const onToggleCardRaw = async (index, key, checked) =>{
	if(checked && !(await ensureRawData())){
		return;
	}
	setRawShowByCard(prev => ({
		...prev,
		[index]: { ...prev[index], [key]: checked }
	}));
	}

	//카드(일자)에 해당하는 raw 전류 데이터 찾기
	const rawDayData = (item) =>{
	if(rawCurrentByDay === null || !item.dayGraphData || !item.dayGraphData.dateTimeList || item.dayGraphData.dateTimeList.length === 0){
		return null;
	}
	const key = localDayKey(item.dayGraphData.dateTimeList[0]); // /api/graph/daily 는 KST 문자열 → 같은 로컬 날짜 키로
	return key === null ? null : (rawCurrentByDay[key] || null);
	}

	//그날 전류 통계 (최고/최저/평균, nA)
	const rawDayStats = (item) =>{
	const d = rawDayData(item);
	if(d === null || d.times.length === 0){
		return null;
	}
	const stat = (arr) =>{
		let max = -Infinity, min = Infinity, sum = 0;
		for(let i = 0; i < arr.length; i++){
			if(arr[i] > max) max = arr[i];
			if(arr[i] < min) min = arr[i];
			sum += arr[i];
		}
		return { max: max, min: min, avg: sum / arr.length };
	};
	return { we1: stat(d.we), we2: stat(d.ae) };
	}

	//⚠️ 버림(floor)이면 부동소수점 합산 오차(14.98 → 14.9799…)가 한 칸 깎여 평균<최저 역전처럼 보임 → 반올림
	const rawFmt = (v) => Math.round(v * 100) / 100;

	const onDownloadCsv = async () =>{
	try{
		//관리자가 다른 유저 프로파일을 보는 중이면 그 유저 기준으로 다운로드 (그래프/혈당값 다운로드와 동일 규칙)
		const userId = secureLocalStorage.getItem('adminViewUserId') ?? (USER_IDENTITY === null ? secureLocalStorage.getItem('authUser') : USER_IDENTITY);
		const startedDt = secureLocalStorage.getItem('userDeviceStartDate');

		const res = await agmsClientDownloadGet(
			`/api/graph/daily/csv?user_id=${userId}&started_dt=${startedDt}`
		);

		//Content-Disposition에서 파일명 추출 (없으면 기본값)
		let fileName = 'AGMS_data.csv';
		const disposition = res.headers['content-disposition'];
		if(disposition){
			const match = disposition.match(/filename="?([^"';]+)"?/i);
			if(match && match[1]){
				fileName = decodeURIComponent(match[1]);
			}
		}

		const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
		const link = document.createElement('a');
		link.href = blobUrl;
		link.setAttribute('download', fileName);
		document.body.appendChild(link);
		link.click();
		link.remove();
		window.URL.revokeObjectURL(blobUrl);
	}
	catch(error){
		if(error.response && error.response.status === 404){
			alert(translate('no_data_download'));
		}
		else{
			alert(translate('download_failed'));
		}
	}
	}

	// 혈당값 CSV 다운로드 — /api/graph/daily(시간·혈당값) 2컬럼. fromDate/toDate('YYYY-MM-DD') 주면 그 기간만, 없으면 전체.
	const onDownloadGlucoseCsv = async (fromDate, toDate) => {
	try{
		const graphUserId = secureLocalStorage.getItem('adminViewUserId') ?? (USER_IDENTITY === null ? secureLocalStorage.getItem('authUser') : USER_IDENTITY);
		const startedDt = secureLocalStorage.getItem('userDeviceStartDate');
		const result = applyStoredGlucose(
			await agmsClientRequestGet(`/api/graph/daily?user_id=${graphUserId}&started_dt=${startedDt}`),
			await fetchStoredGlucoseMap(graphUserId, startedDt)
		);   // 그래프와 같은 값(DB 저장값 기준)
		if(!result || !result.dayGraphData || result.dayGraphData.length === 0){ alert(translate('no_data_download')); return; }

		const from = fromDate ? new Date(fromDate + 'T00:00:00') : null;
		const to   = toDate   ? new Date(toDate   + 'T23:59:59') : null;

		const rows = ['time,glucose'];
		result.dayGraphData.forEach((day) => {
			const times = day.dateTimeList || [];
			const values = day.valueList || [];
			for(let j = 0; j < times.length; j++){
				if(values[j] === null || values[j] === undefined) continue;
				if(from || to){
					const dt = parseServerTime(times[j]); // ISO/KST 문자열 모두 실제 순간으로
					if(from && dt < from) continue;
					if(to && dt > to) continue;
				}
				const t = formatServerTime(times[j], 'YYYY-MM-DD HH:mm:ss', String(times[j]).replace('T', ' '));
				rows.push(`${t},${values[j]}`);
			}
		});
		if(rows.length === 1){ alert(translate('no_data_download')); return; }
		const csv = '﻿' + rows.join('\n');
		const blobUrl = window.URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
		const link = document.createElement('a');
		link.href = blobUrl;
		const suffix = (fromDate || toDate)
			? `${(fromDate||'').replace(/[^0-9]/g,'')}-${(toDate||'').replace(/[^0-9]/g,'')}`
			: String(startedDt || '').replace(/[^0-9]/g, '');
		link.setAttribute('download', `AGMS_glucose_${suffix}.csv`);
		document.body.appendChild(link);
		link.click();
		link.remove();
		window.URL.revokeObjectURL(blobUrl);
		setGlucoseDlOpen(false);
	}
	catch(error){
		alert(translate('download_failed'));
	}
	}

	const onCGMreport = () =>{
	history.push('/CGMreport', {
		middleAreaSeriesData: location.state.middleAreaSeriesData,
		mainUpperAreaSeriesData: location.state.mainUpperAreaSeriesData,
		mainLowerAreaSeriesData: location.state.mainLowerAreaSeriesData,
		lineSeriesData: location.state.lineSeriesData,
		upperLimit: location.state.upperLimit,
		lowerLimit: location.state.lowerLimit
	});
	}

	const callApi = async(input) =>{
	setGraphLoading(true);
	try{
		//API 호출
		let result = null;

		const graphUserId = secureLocalStorage.getItem('adminViewUserId') ?? (USER_IDENTITY === null ? secureLocalStorage.getItem('authUser') : USER_IDENTITY);
		result = await agmsClientRequestGet(
			`/api/graph/daily?user_id=${graphUserId}&started_dt=${secureLocalStorage.getItem('userDeviceStartDate')}`
		);
		// 웹은 DB 저장값 기준(감도표 바꿔도 지난 값 유지). 저장값 없는 점만 재계산 값 — utils/storedGlucose.js
		result = applyStoredGlucose(result, await fetchStoredGlucoseMap(graphUserId, secureLocalStorage.getItem('userDeviceStartDate')));

		let userInfo = await agmsClientRequestGet(`/api/user/info?user_id=${graphUserId}`);

		setTargetGlucose({
			low: userInfo.target_glucose_low,
			high: userInfo.target_glucose_high
		});
		
		//다운로드 시에 사용할 마지막 날짜
		setWeeklyLastDate();

		//좌측에 표시할 날짜 리스트를 만들어준다.
		let tempDateStringList = [];
		for(let i = 0; i< result.eventCount.length; i++){
			if(result.dayGraphData[i].maxValue === null || result.dayGraphData[i].minValue === null){
				continue;
			}
			let tempDate = parseServerTime(result.dayGraphData[i].dateTimeList[0]);
			let tempString = (tempDate.month() + 1) + '/' + tempDate.date() + '(' + days[tempDate.day()]+')'; 
			tempDateStringList.push(tempString);
		}
		setDateList(tempDateStringList);

		//좌측 상단에 나타날 기간 값을 지정해준다.
		let startDate = parseServerTime(result.dayGraphData[0].dateTimeList[0]);
		let endDate = parseServerTime(result.dayGraphData[result.eventCount.length-1].dateTimeList[0]);

		setDateRange({
			startYear: startDate.year(),
			startMonth: (startDate.month() + 1) < 10 ? '0' + (startDate.month() + 1):  startDate.month() + 1 ,
			startDate: startDate.date(),
			endYear: endDate.year(),
			endMonth: (endDate.month() + 1) < 10 ? '0' + (endDate.month() + 1):  endDate.month() + 1 ,
			endDate: endDate.date()
		});
		
		//날짜 갯수만큼 정보를 담아 카드 리스트를 만들어준다.
		let tempList = [];
		
		if(result !== null){
			for(let i = 0; i < result.maxGlucose.length; i++){
				if(result.dayGraphData[i].maxValue === null || result.dayGraphData[i].minValue === null){
					continue;
				}
				var tempObject = {
					dayGraphData: result.dayGraphData[i],
					avgGlucose: result.avgGlucose[i],
					exceedUpperPercent: result.exceedUpperPercent[i],
					exceedLowerPercent: result.exceedLowerPercent[i]
				}

				tempList.push(tempObject);
			}
			setCardList(tempList);
		}
		

		//최고혈당, 최저혈당 리스트 set
		let maxTempList = [];
		let minTempList = [];

		for(let i = 0; i < result.dayGraphData.length; i++){
			if(result.dayGraphData[i].maxValue === null || result.dayGraphData[i].minValue === null){
				continue;
			}
			
			let maxDate = parseServerTime(result.dayGraphData[i].maxValue.created_at);
			let minDate = parseServerTime(result.dayGraphData[i].minValue.created_at);
			
			maxTempList.push(
				{
				max_value: result.dayGraphData[i].maxValue.value,
				created_at: (maxDate.hour() <= 9 ? ('0' + maxDate.hour()) : maxDate.hour()) + ':' + (maxDate.minute() <= 9 ? ('0'+ maxDate.minute()) : maxDate.minute())
				}
			);
			minTempList.push(
				{
				min_value: result.dayGraphData[i].minValue.value,
				created_at: (minDate.hour() <= 9 ? ('0' + minDate.hour()) : minDate.hour()) + ':' + (minDate.minute() <= 9 ? ('0'+ minDate.minute()) : minDate.minute())
				}
			);
		}
		setMaxList(maxTempList);
		setMinList(minTempList);
		setApiResult(result);
	}
	catch(error){
		setGraphLoading(false);
	}
	setGraphLoading(false);
	}

	// useEffect(() => {
	//   callApi(secureLocalStorage.getItem("authUser"));
	// },[isCurrentBloodSugar]);

	// useEffect(() => {
	//   callApi(secureLocalStorage.getItem("authUser"));
	// },[selectedPatientId]);

	useEffect(() => {
	secureLocalStorage.setItem('startDate', dateRange.startYear + '-' + dateRange.startMonth + '-' + dateRange.startDate);
	secureLocalStorage.setItem('endDate', dateRange.endYear + '-' + dateRange.endMonth + '-' + dateRange.endDate);
	},[dateRange])

	useEffect(()=>{
		//let tempUserData = JSON.parse(secureLocalStorage.getItem('selectedExperimentValue'));
		let tempUserData = secureLocalStorage.getItem('userInfo');
		setPatientValue({
			name: tempUserData.name,
			code: ''
		});
		callApi(secureLocalStorage.getItem("authUser"));
	},[]);


	const [annotationChartYAxis, setAnnotationChartYAxis] = useRecoilState(annotationChartYAxisAtom);

	const textFieldMaxRef = useRef(200);
	const textFieldMinRef = useRef(-200);

	const [open, setOpen] = React.useState(false);


	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	const [yAxisMaxValue, setYAxisMaxValue] = React.useState(200);
	const onChangeYAxisMaxValue = (event) =>{
	setYAxisMaxValue(event.target.value);
	}
	const [yAxisMinValue, setYAxisMinValue] = React.useState(-200);
	const onChangeYAxisMinValue = (event) =>{
	setYAxisMinValue(event.target.value);
	}

	const onSaveYAxisValue = () => { 
	let tempMax = textFieldMaxRef.current.value;
	let tempMin = textFieldMinRef.current.value;

	if(typeof(tempMax) == 'string'){
		tempMax = parseInt(tempMax);
	}
	if(typeof(tempMin) == 'string'){
		tempMin = parseInt(tempMin);
	}
	setAnnotationChartYAxis({
		min: tempMin,
		max: tempMax
	});
	callApi(secureLocalStorage.getItem("selectedPatientId"));
	setOpen(false);
	}

	return (
		<div
			className="row w-100 h-100 "
			style={{ padding: "0px 70px", marginTop: "30px"}}
		>
			<div className="panel-body" style={{maxWidth:'1500px', minWidth:'1400px', marginLeft:'auto', marginRight:'auto'}}>
			<div style={{width: '100%', marginTop: "10px"}}></div>
			
			<div className="row ">
				<div className="col">
				<div style={{display:'flex',  alignItems:'center', marginBottom:'10px'}}>
					<div style={{flex: 0.9, fontSize:'23px'}}>
						{translate('period')} {dateRange.startYear}-{dateRange.startMonth}-{dateRange.startDate} ~ {dateRange.endYear}-{dateRange.endMonth}-{dateRange.endDate}
					</div>

					<div style={{flex:0.2}}>
					<FormControl fullWidth>
						<InputLabel id="demo-simple-select-label">{translate('graph_interval')}</InputLabel>
						<Select
						labelId="demo-simple-select-label"
						id="demo-simple-select"
						value={xMinutes}
						label={translate('graph_interval')}
						onChange={handleChange}
						>
						<MenuItem value={1}>{translate('1min')}</MenuItem>
						<MenuItem value={5}>{translate('5min')}</MenuItem>
						<MenuItem value={15}>{translate('15min')}</MenuItem>
						<MenuItem value={30}>{translate('30min')}</MenuItem>
						<MenuItem value={60}>{translate('60min')}</MenuItem>
						</Select>
					</FormControl>
					</div>

					<div style={{flex:0.2, paddingLeft:'20px'}}>
					{/* <Button 
						variant="contained" 
						size="medium" 
						style={{ backgroundColor : '#DCD7E2', color:'#000000', fontSize:'16px'}}
						onClick={handleOpen}
					>
						Y축 간격
					</Button> */}
					<Modal
						aria-labelledby="transition-modal-title"
						aria-describedby="transition-modal-description"
						open={open}
						onClose={handleClose}
						closeAfterTransition
						slots={{ backdrop: Backdrop }}
						slotProps={{
						backdrop: {
							timeout: 500,
						},
						}}
					>
						<Fade in={open}>
						<Box sx={style}>
							<div style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
							<div style={{display:'flex', justifyContent:'center', alignItems:'center', marginRight:'5px', fontSize:'15px'}}>
								Y축 최대 : 
							</div>
							<TextField inputRef={textFieldMaxRef} id="outlined-basic" label="최댓값" variant="outlined" />
							</div>
							<div style={{height:'20px'}}></div>

							<div style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
							<div style={{display:'flex', justifyContent:'center', alignItems:'center', marginRight:'5px', fontSize:'15px'}}>
								Y축 최소 : 
							</div>
							<TextField inputRef={textFieldMinRef} id="outlined-basic" label="최솟값" variant="outlined" />
							</div>
							
							<div>
							<Button onClick={onSaveYAxisValue} style={{fontSize:'15px'}}>저장</Button>
							</div>
						</Box>
						</Fade>
					</Modal>

					{/* 혈당 데이터 다운로드 팝업 — 기간 설정 / 전체 다운로드 (일반관리자↑) */}
					<Modal
						open={glucoseDlOpen}
						onClose={() => setGlucoseDlOpen(false)}
						closeAfterTransition
						slots={{ backdrop: Backdrop }}
						slotProps={{ backdrop: { timeout: 500 } }}
					>
						<Fade in={glucoseDlOpen}>
						<Box sx={glucoseStyle}>
							<div style={{fontSize:'20px', fontWeight:'bold', textAlign:'center', marginBottom:'20px'}}>혈당 데이터 다운로드</div>
							<div style={{display:'flex', alignItems:'center', gap:'10px', justifyContent:'center', marginBottom:'20px'}}>
								<TextField type="date" label="시작일" size="small" InputLabelProps={{ shrink: true }} value={gFrom} onChange={e => setGFrom(e.target.value)} />
								<span>~</span>
								<TextField type="date" label="종료일" size="small" InputLabelProps={{ shrink: true }} value={gTo} onChange={e => setGTo(e.target.value)} />
							</div>
							<div style={{display:'flex', gap:'10px', justifyContent:'center'}}>
								<Button variant="contained" disabled={!gFrom || !gTo}
									style={{ backgroundColor: (!gFrom || !gTo) ? '#c9c9c9' : '#787397', color:'#fff', fontSize:'15px' }}
									onClick={() => onDownloadGlucoseCsv(gFrom, gTo)}>
									<b>기간 다운로드</b>
								</Button>
								<Button variant="contained"
									style={{ backgroundColor:'#DCD7E2', color:'#000', fontSize:'15px' }}
									onClick={() => onDownloadGlucoseCsv()}>
									<b>전체 다운로드</b>
								</Button>
							</div>
						</Box>
						</Fade>
					</Modal>
					</div>


					<div style={{flex: 0.7, display:'flex', flexDirection:'row',justifyContent:'center', alignItems:'center'}}>
					<div style={{display:'flex', flexDirection:'row'}}>
						<div style={{backgroundColor:'#7C7BBA', width:'30px', borderRadius:'5px'}} />
						<div style={{marginLeft:'5px'}}>
						Calibration
						</div>
					</div> 
					<div style={{display:'flex', flexDirection:'row'}}>
						<div style={{backgroundColor:'#E9979F', width:'30px',borderRadius:'5px', marginLeft:'15px'}} />
						<div style={{marginLeft:'5px'}}>
						{translate('meal')}
						</div>
					</div> 
					<div style={{display:'flex', flexDirection:'row'}}>
						<div style={{backgroundColor:'#B9D7E3', width:'30px',borderRadius:'5px',marginLeft:'15px'}} />
						<div style={{marginLeft:'5px'}}>
						{translate('activity')}
						</div>
					</div> 
					</div>

					{/* <div style={{flex: 0.8, display:'flex', justifyContent:'center' ,alignItems:'center', fontSize:'23px'}}>
					성명 : {patientValue.name} ({patientValue.code})
					</div> */}



					<div style={{flex: 1, display:'flex', justifyContent:'end', alignItems:'center'}}>
					<span style={{fontSize:'23px', paddingRight:'15px', whiteSpace:'nowrap'}}>{translate('name_daily')} {patientValue.name} </span>
					{/* 데이터(raw) 다운로드 — 확증임상 요구(8/25): 최고 관리자(1001)만 노출 */}
					{isSuperAdmin && (
					<Button variant="contained" size="medium" style={{ backgroundColor : '#DCD7E2', color:'#000000', fontSize:'16px', marginRight:'10px', whiteSpace:'nowrap'}} onClick={onDownloadCsv}>
						<b>{translate('download_data')}</b>
					</Button>
					)}
					{/* 혈당 데이터 다운로드 — 일반관리자(1002)↑만. 클릭 시 팝업(기간 설정 / 전체) */}
					{isSubAdminOrAbove && (
					<Button variant="contained" size="medium" style={{ backgroundColor : '#DCD7E2', color:'#000000', fontSize:'16px', marginRight:'10px', whiteSpace:'nowrap'}} onClick={() => { setGFrom(''); setGTo(''); setGlucoseDlOpen(true); }}>
						<b>{translate('download_glucose')}</b>
					</Button>
					)}
					<Button variant="contained" size="medium" style={{ backgroundColor : '#DCD7E2', color:'#000000', fontSize:'16px', whiteSpace:'nowrap'}} onClick={onCGMreport}>
						<b>{translate('view_report')}</b>
					</Button>
					</div>
				</div>

				{/* <div style={{width:'200px', marginBottom:'10px', marginTop:'10px'}}>
					<FormControl fullWidth>
					<InputLabel id="demo-simple-select-label">그래프 간격</InputLabel>
					<Select
						labelId="demo-simple-select-label"
						id="demo-simple-select"
						value={xMinutes}
						label="그래프 간격"
						onChange={handleChange}
					>
						<MenuItem value={1}>1분</MenuItem>
						<MenuItem value={5}>5분</MenuItem>
						<MenuItem value={15}>15분</MenuItem>
						<MenuItem value={30}>30분</MenuItem>
						<MenuItem value={60}>1시간</MenuItem>
					</Select>
					</FormControl>
				</div> */}
				<Grid container spacing={1}>
					{cardList.map((item, index) => (
					<Grid xs={12} key={index}>
						<Item>
							<div className="row align-items-center justify-content-between">
							<div className="col-1">
								<div style={{fontSize:'30px'}}><b>{dateList[index]}</b></div>
								<div style={{fontSize:'15px'}}>{translate('glucose')} ({isCurrentBloodSugar ? 'mg/dL' : 'nA'})</div>
								<div></div>
							</div>
							<div className="col-6" >
								{graphLoading == true ? <CircularProgress /> : <AnnotationChart chartData={item.dayGraphData} graphXminutes={xMinutes} targetGlucose={targetGlucose}/>}
							</div>

							<div className="col-5" >
								<Grid container spacing={1}>
								<Grid xs={2.4}>
									<Paper style={{border:'1px solid #000000', padding:'1em', marginLeft:'5px'}}>
									<Badge color='error' badgeContent=" " variant="dot">
										<div className="row" style={{fontSize:'16px', display:'flex', justifyContent:'center', alignItems:'center', height:'30px'}}>
										{translate('max')} {' '} {isCurrentBloodSugar ? translate('short_glucose') : '전류'}
										</div>
									</Badge>
									<div>{isCurrentBloodSugar ? 'mg/dL' : 'nA'}</div>
									<div className="row align-items-center justify-content-between" style={{fontSize: '30px', height:'50px', color:'#D32F2F'}}>
										<b>{maxList[index] !== undefined  && (isCurrentBloodSugar ? Math.round(maxList[index].max_value) : Math.floor(maxList[index].max_value *100)/100) }</b> 
									</div>
									<div>
										{maxList[index]!== undefined  && maxList[index].created_at }
									</div>
									</Paper>
								</Grid>
								<Grid xs={2.4}>
									<Paper style={{border:'1px solid #000000', padding:'1em'}}>
									<Badge color="warning" badgeContent=" " variant="dot"> 
										<div className="row" style={{fontSize:'16px', display:'flex', justifyContent:'center', alignItems:'center', height:'30px'}}>
										{translate('min')} {' '} {isCurrentBloodSugar ? translate('short_glucose') : '전류'}
										</div>
									</Badge>
									<div>{isCurrentBloodSugar ? 'mg/dL' : 'nA'}</div>
									<div className="row align-items-center justify-content-between" style={{fontSize: '30px', height:'50px', color:'#ED6C02'}}>
										<b>{minList[index] !== undefined && (isCurrentBloodSugar ? Math.round(minList[index].min_value) : Math.floor(minList[index].min_value *100)/100) }</b>
									</div>
									<div>
										{minList[index]!== undefined  && minList[index].created_at }
									</div>
									</Paper>
								</Grid>
								<Grid xs={2.4}>
									<Paper style={{border:'1px solid #000000',padding:'1em'}}>
									<div className="row" style={{fontSize:'16px', display:'flex', justifyContent:'center', alignItems:'center', height:'30px'}}>
										{translate('average')} {' '} {isCurrentBloodSugar ? translate('short_glucose') : '전류'}
									</div>
									<div>{isCurrentBloodSugar ? 'mg/dL' : 'nA'}</div>
									<div className="row align-items-center justify-content-between" style={{fontSize: '30px', height:'70px', }}>
										<b>{isCurrentBloodSugar ? Math.round(item.avgGlucose) : Math.floor(item.avgGlucose*100)/100}</b>
									</div>
									</Paper>
								</Grid>
								<Grid xs={2.4}>
									<Paper style={{border:'1px solid #000000',padding:'1em'}}>
									<div className="row" style={{fontSize:'16px', display:'flex', justifyContent:'center', alignItems:'center', height:'30px'}}>
										{translate('exceedUpperPercent')}
									</div>
									<div>
										%
									</div>
									<div className="row align-items-center justify-content-between" style={{fontSize: '30px', height:'70px', }}><b>{item.exceedUpperPercent}</b></div>
									</Paper>
								</Grid>
								<Grid xs={2.4}>
									<Paper style={{border:'1px solid #000000',padding:'1em'}}>
									<div className="row" style={{fontSize:'16px', display:'flex', justifyContent:'center', alignItems:'center', height:'30px'}}>
										{translate('exceedLowerPercent')}
									</div>
									<div>
										%
									</div>
									<div className="row align-items-center justify-content-between" style={{fontSize: '30px', height:'70px', }}><b>{item.exceedLowerPercent}</b></div>
									</Paper>
								</Grid>
								</Grid>
							</div>
							</div>

							{/* 최고 관리자 전용 — raw 전류(WE1/WE2) 영역: 카드 전체 폭 점선 아래, 날짜별 개별 토글 */}
							{isSuperAdmin && (
							<>
							{rawShowByCard[index] && (rawShowByCard[index].we1 || rawShowByCard[index].we2) && (
							<div style={{borderTop:'1.5px dashed #C0C0C0', margin:'10px 0 0 0'}}></div>
							)}
							<div className="row align-items-center justify-content-between">
								<div className="col-1">
									<div style={{display:'flex', flexDirection:'column', alignItems:'flex-start'}}>
										<FormControlLabel
											style={{margin:'0px', whiteSpace:'nowrap'}}
											control={<Checkbox size="small" style={{padding:'2px'}} checked={!!(rawShowByCard[index] && rawShowByCard[index].we1)} disabled={rawLoading} onChange={(e) => onToggleCardRaw(index, 'we1', e.target.checked)} />}
											label={<span style={{fontSize:'14px'}}>WE1</span>}
										/>
										<FormControlLabel
											style={{margin:'0px', whiteSpace:'nowrap'}}
											control={<Checkbox size="small" style={{padding:'2px'}} checked={!!(rawShowByCard[index] && rawShowByCard[index].we2)} disabled={rawLoading} onChange={(e) => onToggleCardRaw(index, 'we2', e.target.checked)} />}
											label={<span style={{fontSize:'14px'}}>WE2</span>}
										/>
									</div>
								</div>
								<div className="col-6" >
									{rawShowByCard[index] && (rawShowByCard[index].we1 || rawShowByCard[index].we2) && graphLoading == false && (
										<RawCurrentChart dayData={rawDayData(item)} graphXminutes={xMinutes} showWe1={!!rawShowByCard[index].we1} showWe2={!!rawShowByCard[index].we2} />
									)}
								</div>
								<div className="col-5" >
									{rawShowByCard[index] && (rawShowByCard[index].we1 || rawShowByCard[index].we2) && rawDayStats(item) !== null && (
									<Grid container spacing={1}>
										{[
											{ label: '최고 전류', pick: (s) => s.max },
											{ label: '최저 전류', pick: (s) => s.min },
											{ label: '평균 전류', pick: (s) => s.avg }
										].map((card, ci) => (
										<Grid xs={2.4} key={ci}>
											<Paper style={{border:'1px solid #000000', padding:'1em', marginLeft: ci === 0 ? '5px' : '0px'}}>
											<div className="row" style={{fontSize:'16px', display:'flex', justifyContent:'center', alignItems:'center', height:'30px'}}>
												{card.label}
											</div>
											<div>nA</div>
											<div style={{fontSize:'20px', minHeight:'70px', display:'flex', flexDirection:'column', justifyContent:'center'}}>
												{rawShowByCard[index].we1 && (
													<div style={{color:'#1976D2'}}><b>{rawFmt(card.pick(rawDayStats(item).we1))}</b></div>
												)}
												{rawShowByCard[index].we2 && (
													<div style={{color:'#9C27B0'}}><b>{rawFmt(card.pick(rawDayStats(item).we2))}</b></div>
												)}
											</div>
											</Paper>
										</Grid>
										))}
									</Grid>
									)}
								</div>
							</div>
							</>
							)}
						</Item>
					</Grid>
					))}
				</Grid>
				</div>
			</div>
			</div>
		</div>
	);
};

export default withRouter(WeeklyChartList);
